<search-panel
  header="FORM_LABEL.SEARCH_VOYAGE"
  [showExcel]="true"
  [excelDisabled]="excelDisabled"
  [(open)]="isOpen"
  (clearFilters)="clearFilters()"
  (submitForm)="onSubmit()"
  (exportAsExcel)="exportAsExcel.emit()"
>
  <div class="col-12 col-md-4 col-xl-3">
    <auto-select
      id="originAgentId"
      bindValue="id"
      [fc]="formGroup.get('originAgentId')"
      [change]="searchAgents"
      [bindLabel]="['displayName']"
      [placeholder]="'LABELS.ORIGIN_AGENT' | translate"
    ></auto-select>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <app-control-wrapper [control]="formGroup.get('voyageType')">
      <ng-select
        id="voyageType"
        class="custom"
        control-wrapper
        bindLabel="label"
        bindValue="value"
        [formControl]="formGroup.get('voyageType')"
        [items]="voyageTypesItems"
        [placeholder]="'LABELS.VOYAGE_TYPE' | translate"
        [clearable]="true"
      ></ng-select>
    </app-control-wrapper>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <auto-select
      id="destinationAgentId"
      bindValue="id"
      [fc]="formGroup.get('destinationAgentId')"
      [change]="searchAgents"
      [bindLabel]="['displayName']"
      [placeholder]="'LABELS.DESTINATION_AGENT' | translate"
    ></auto-select>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <auto-select
      id="freightAgentId"
      bindValue="id"
      [fc]="formGroup.get('freightAgentId')"
      [change]="searchAgents"
      [bindLabel]="['displayName']"
      [placeholder]="'LABELS.FREIGHT_AGENT' | translate"
    ></auto-select>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <app-control-wrapper [control]="formGroup.get('statuses')">
      <ng-select
        control-wrapper
        id="statuses"
        class="custom"
        bindValue="value"
        multiple="true"
        placeholder="{{ 'LABELS.STATUS' | translate }}"
        [formControl]="formGroup.get('statuses')"
        [items]="statusItems"
      ></ng-select>
    </app-control-wrapper>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <app-control-wrapper [control]="formGroup.get('voyageReferenceNumber')">
      <input
        control-wrapper
        type="text"
        id="voyageReferenceNumber"
        class="form-control"
        name="voyageReferenceNumber"
        placeholder="{{ 'LABELS.REFERENCE_NUMBER' | translate }}"
        [formControl]="formGroup.get('voyageReferenceNumber')"
        [dropSpecialCharacters]="false"
        [patterns]="CUSTOM_MASK"
        [mask]="'F{10}'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        [maxMaskLength]="10"
      />
    </app-control-wrapper>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <app-control-wrapper [control]="formGroup.get('voyageNumber')">
      <input
        control-wrapper
        type="text"
        id="voyageNumber"
        class="form-control"
        name="voyageNumber"
        placeholder="{{ 'LABELS.VOYAGE_NUMBER' | translate }}"
        [formControl]="formGroup.get('voyageNumber')"
        [dropSpecialCharacters]="false"
        [patterns]="CUSTOM_MASK"
        [mask]="'F{5}'"
        [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
        [maxMaskLength]="5"
      />
    </app-control-wrapper>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <auto-select
      id="fromPort"
      bindValue="id"
      [fc]="formGroup.get('fromPort')"
      [change]="searchPorts"
      [bindLabel]="['code', 'description']"
      [placeholder]="'LABELS.FROM_PORT' | translate"
    ></auto-select>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <auto-select
      id="toPort"
      bindValue="id"
      [fc]="formGroup.get('toPort')"
      [change]="searchPorts"
      [bindLabel]="['code', 'description']"
      [placeholder]="'LABELS.TO_PORT' | translate"
    ></auto-select>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <date-picker
      id="departureDateFrom"
      placeholder="LABELS.DEPARTURE_DATE_FROM"
      name="departureDateFrom"
      [fc]="formGroup.get('departureDateFrom')"
    ></date-picker>
  </div>

  <div class="col-12 col-md-4 col-xl-3">
    <date-picker
      id="departureDateTo"
      placeholder="LABELS.DEPARTURE_DATE_TO"
      name="departureDateTo"
      [fc]="formGroup.get('departureDateTo')"
    ></date-picker>
  </div>
</search-panel>
